import React, { useState } from "react";
import styles from "./Button.module.css";
import { ButtonProps } from "@/types/ui.types";

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className = "",
      variant = "default",
      icon,
      iconPosition = "left",
      children,
      onClick,
      disabled, 
      ...props 
    },
    ref
  ) => {
    
    const variantClass = {
      customRed: styles.buttonCustomRed,
      outlined: styles.buttonOutlined,
      customGray: styles.buttonCustomGray,
      iconOnly: styles.buttonIconOnly,
      purplePill: styles.buttonPurplePill,
      whitePill: styles.buttonWhitePill,
      default: "", 
    }[variant] || "";

    const [isRotated, setIsRotated] = useState(false);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      if (disabled) return;

      if (iconPosition === "right") {
        setIsRotated((prev) => !prev);
      }
      if (onClick) {
        onClick(event);
      }
    };

    let mainContent = children;
    let rightIcon = iconPosition === "right" ? icon : null;

    if (!icon) {
      const childrenArray = React.Children.toArray(children);
      if (iconPosition === "right" && childrenArray.length > 1) {
        rightIcon = childrenArray[childrenArray.length - 1];
        mainContent = childrenArray.slice(0, childrenArray.length - 1);
      }
    }

    return (
      <button
        ref={ref}
        disabled={disabled} 
        className={`${styles.button} ${variantClass} ${className} button`}
        onClick={handleClick}
        {...props} 
      >
        {mainContent}
        {rightIcon && (
          <span className={`${styles.buttonIconRight} ${isRotated ? styles.rotated : ""}`}>
            {rightIcon}
          </span>
        )}
      </button>
    );
  }
);

Button.displayName = "Button";